export default __webpack_public_path__ + "static/ActaHeadline-BookItalic-cb3a3398144cd0c52881864315d95c83.woff";